import React, { useEffect, useState } from 'react';
import { FiSearch, FiX, FiShield, FiUser } from 'react-icons/fi';
import API from '../utils/api';
import { toast } from 'react-toastify';
import './AdminPages.css';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const fetch = () => {
    setLoading(true);
    API.get('/api/admin/users')
      .then(r => setUsers(r.data.data))
      .catch(() => toast.error('Failed to load users'))
      .finally(() => setLoading(false));
  };
  useEffect(fetch, []);

  const toggleRole = async (u) => {
    const newRole = u.role === 'admin' ? 'user' : 'admin';
    if (!window.confirm(`Change ${u.name} to ${newRole}?`)) return;
    try {
      await API.put(`/api/admin/users/${u._id}/role`, { role: newRole });
      toast.success('Role updated');
      fetch();
    } catch { toast.error('Failed'); }
  };

  const filtered = users.filter(u =>
    u.name?.toLowerCase().includes(search.toLowerCase()) ||
    u.email?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="admin-page-header">
        <div><h2>Users</h2><p>{users.length} registered users</p></div>
      </div>
      <div className="admin-card">
        <div className="admin-card-header">
          <div className="admin-filters" style={{ margin: 0 }}>
            <div className="admin-search">
              <FiSearch />
              <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search users..." />
              {search && <button style={{ position:'absolute',right:10,background:'none',border:'none',cursor:'pointer' }} onClick={() => setSearch('')}><FiX /></button>}
            </div>
          </div>
        </div>
        <div className="admin-table-wrap">
          {loading ? <div className="spinner" style={{ margin:'40px auto' }} /> : (
            <table className="admin-table">
              <thead><tr><th>Name</th><th>Email</th><th>Phone</th><th>Role</th><th>Joined</th><th>Actions</th></tr></thead>
              <tbody>
                {filtered.map(u => (
                  <tr key={u._id}>
                    <td>
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <div style={{ width:34,height:34,borderRadius:'50%',background:'linear-gradient(135deg,var(--primary),var(--primary-light))',color:'white',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:'0.9rem',flexShrink:0 }}>
                          {u.name?.charAt(0).toUpperCase()}
                        </div>
                        {u.name}
                      </div>
                    </td>
                    <td>{u.email}</td>
                    <td>{u.phone || '—'}</td>
                    <td><span className={`badge-status ${u.role}`}>{u.role}</span></td>
                    <td>{new Date(u.createdAt).toLocaleDateString('en-IN', { day:'numeric', month:'short', year:'numeric' })}</td>
                    <td>
                      <button
                        className={`btn-action ${u.role === 'admin' ? 'delete' : 'view'}`}
                        onClick={() => toggleRole(u)}
                        title={u.role === 'admin' ? 'Remove Admin' : 'Make Admin'}
                      >
                        {u.role === 'admin' ? <FiUser /> : <FiShield />}
                      </button>
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && <tr><td colSpan={6}><div className="admin-empty">No users found</div></td></tr>}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
